import { Heading, Inline, Stack, Text, textVariants } from '@etg/wings';
import { BrandLogo } from '@eti/components';
import { useSiteContext, useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';
import { constants } from '@eti/utils';
import Media from 'react-media';

const headingBrandStyles = css`
  justify-content: space-between;
`;

const brandLogoStyles = css`
  height: 25px;
`;

const brandLogoMobileStyles = css`
  flex-shrink: 0;
  height: 14px;
`;

const texts = {
  etgFaresTitle: 'Product.ETG.Fares.Title',
  etgFaresTitleZeroPercentage: 'Product.ETG.Fares.Title.DiscountZeroPercentage',
  numberOfAvailableOption: 'Product.ETG.Fares.Number.Available.Option.Text',
  discountPercentageTitle: 'Product.ETG.Fares.DiscountPercentage.Title',
  discountZeroPercentageTitle: 'Product.ETG.Fares.DiscountZeroPercentage.Title',
};

export interface EtgFaresHeadingProps {
  discountPercentage: number;
  hasDiscount: boolean;
  numberOfSellableOptions: number;
  savedAmount: string;
}

const EtgFaresHeading = ({
  discountPercentage,
  hasDiscount,
  numberOfSellableOptions,
  savedAmount,
}: EtgFaresHeadingProps) => {
  const { t } = useTranslation();
  const { brand } = useSiteContext();
  const { FLIGHTNETWORK } = constants.brands;

  const etgFaresTitle = hasDiscount
    ? t(texts.etgFaresTitle, discountPercentage)
    : t(texts.etgFaresTitleZeroPercentage);
  const discountPercentageTitle = hasDiscount
    ? t(texts.discountPercentageTitle, savedAmount)
    : t(texts.discountZeroPercentageTitle);

  return (
    <Stack spacing={8}>
      <Media query={mediaQueries.medium.up}>
        {(matches) =>
          matches ? (
            <Inline alignY="center" className={headingBrandStyles} spacing={4}>
              <Heading level={2}>{etgFaresTitle}</Heading>
              <Stack align="end" spacing={4}>
                <BrandLogo
                  brand={brand.code}
                  className={brandLogoStyles}
                  shouldUseContrast={brand.code === FLIGHTNETWORK}
                />
                <Text>{t(texts.numberOfAvailableOption, numberOfSellableOptions)}</Text>
              </Stack>
            </Inline>
          ) : (
            <Stack spacing={8}>
              <Inline className={headingBrandStyles} noWrap spacing={8}>
                <Heading level={2}>{etgFaresTitle}</Heading>
                <BrandLogo
                  brand={brand.code}
                  className={brandLogoMobileStyles}
                  shouldUseContrast={brand.code === FLIGHTNETWORK}
                />
              </Inline>
              <Text>{t(texts.numberOfAvailableOption, numberOfSellableOptions)}</Text>
            </Stack>
          )
        }
      </Media>
      <Text variant={textVariants._16}>{discountPercentageTitle}</Text>
    </Stack>
  );
};

export default EtgFaresHeading;
